import { Card } from "react-bootstrap";

/* =========================
 * COLUMN COLOR CONFIG
 * ========================= */
const COLUMN_COLORS = {
  CPIB: "#1677FF",
  CBIB: "#FA8C16",
  CPPIB: "#F5222D",
  CPOIB: "#08979C",
  CBIB_Kapal: "#2F54EB",
  CDOIB: "#52C41A",
  JUMLAH: "#595959",
};

/* =========================
 * COMPONENT
 * ========================= */
function Top5Table({ data = [] }) {
  return (
    <Card className="border-0 shadow-sm h-100">
      <Card.Body className="p-2">
        <h6 className="fw-semibold mb-3 text-left">
          Top 7 Sertifikasi per Provinsi
        </h6>

        <div className="table-responsive">
          <table className="table table-sm table-bordered align-middle mb-0 small">
            <thead className="table-light">
              <tr className="text-center">
                <th style={{ width: 30 }}>#</th>
                <th className="text-start">Provinsi</th>
                <th style={{ color: COLUMN_COLORS.CPIB }}>CPIB</th>
                <th style={{ color: COLUMN_COLORS.CBIB }}>CBIB</th>
                <th style={{ color: COLUMN_COLORS.CPPIB }}>CPPIB</th>
                <th style={{ color: COLUMN_COLORS.CPOIB }}>CPOIB</th>
                <th style={{ color: COLUMN_COLORS.CBIB_Kapal }}>Kap.</th>
                <th style={{ color: COLUMN_COLORS.CDOIB }}>CDOIB</th>
                <th style={{ color: COLUMN_COLORS.JUMLAH }}>∑</th>
              </tr>
            </thead>

            <tbody>
              {data.length === 0 && (
                <tr>
                  <td colSpan={9} className="text-center text-muted py-3">
                    Data belum tersedia
                  </td>
                </tr>
              )}

              {data.map((row, i) => {
                const jumlah =
                  (row.CPIB || 0) +
                  (row.CBIB || 0) +
                  (row.CPPIB || 0) +
                  (row.CPOIB || 0) +
                  (row.CBIB_Kapal || 0) +
                  (row.CDOIB || 0);

                return (
                  <tr key={row.propinsi || i} className="text-center">
                    <td>{i + 1}</td>

                    <td className="text-start text-nowrap">
                      {row.propinsi}
                    </td>

                    <td style={{ color: COLUMN_COLORS.CPIB }}>
                      {row.CPIB ?? 0}
                    </td>

                    <td style={{ color: COLUMN_COLORS.CBIB }}>
                      {row.CBIB ?? 0}
                    </td>

                    <td style={{ color: COLUMN_COLORS.CPPIB }}>
                      {row.CPPIB ?? 0}
                    </td>

                    <td style={{ color: COLUMN_COLORS.CPOIB }}>
                      {row.CPOIB ?? 0}
                    </td>

                    <td style={{ color: COLUMN_COLORS.CBIB_Kapal }}>
                      {row.CBIB_Kapal ?? 0}
                    </td>

                    <td style={{ color: COLUMN_COLORS.CDOIB }}>
                      {row.CDOIB ?? 0}
                    </td>

                    <td
                      className="fw-bold"
                      style={{ color: COLUMN_COLORS.JUMLAH }}
                    >
                      {jumlah}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Card.Body>
    </Card>
  );
}

export default Top5Table;
